'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShakeCrazy = exports.ShakeRotate = exports.ShakeVertical = exports.ShakeHorizontal = exports.ShakeHard = exports.ShakeSlow = exports.ShakeLittle = exports.shakes = exports.Shaking = exports.Shake = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Shake = require('./Shake');

Object.defineProperty(exports, 'Shake', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Shake).default;
  }
});

var _Shaking = require('./Shaking');

Object.defineProperty(exports, 'Shaking', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Shaking).default;
  }
});

var _shakes = require('./shakes');

Object.defineProperty(exports, 'shakes', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_shakes).default;
  }
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Shake2 = _interopRequireDefault(_Shake);

var _Shaking2 = _interopRequireDefault(_Shaking);

var _shakes2 = _interopRequireDefault(_shakes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ShakeLittle = exports.ShakeLittle = function ShakeLittle(props) {
  return _react2.default.createElement(_Shaking2.default, _extends({}, props, { type: 'little' }));
};
var ShakeSlow = exports.ShakeSlow = function ShakeSlow(props) {
  return _react2.default.createElement(_Shaking2.default, _extends({}, props, { type: 'slow' }));
};
var ShakeHard = exports.ShakeHard = function ShakeHard(props) {
  return _react2.default.createElement(_Shaking2.default, _extends({}, props, { type: 'hard' }));
};
var ShakeHorizontal = exports.ShakeHorizontal = function ShakeHorizontal(props) {
  return _react2.default.createElement(_Shaking2.default, _extends({}, props, { type: 'horizontal' }));
};
var ShakeVertical = exports.ShakeVertical = function ShakeVertical(props) {
  return _react2.default.createElement(_Shaking2.default, _extends({}, props, { type: 'vertical' }));
};
var ShakeRotate = exports.ShakeRotate = function ShakeRotate(props) {
  return _react2.default.createElement(_Shaking2.default, _extends({}, props, { type: 'rotate' }));
};
var ShakeCrazy = exports.ShakeCrazy = function ShakeCrazy(props) {
  return _react2.default.createElement(_Shaking2.default, _extends({}, props, { type: 'crazy' }));
};

exports.default = {
  Shake: _Shake2.default,
  Shaking: _Shaking2.default,
  shakes: _shakes2.default,
  ShakeLittle: ShakeLittle,
  ShakeSlow: ShakeSlow,
  ShakeHard: ShakeHard,
  ShakeHorizontal: ShakeHorizontal,
  ShakeVertical: ShakeVertical,
  ShakeRotate: ShakeRotate,
  ShakeCrazy: ShakeCrazy
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/reshake/dist/index.js
// module id = 62
// module chunks = 0